export default __webpack_public_path__ + "static/media/phientharntham.13643c59.mp4";